var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container",staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"},on:{"contextmenu":function($event){$event.preventDefault();}}},[_c('iframe',{staticStyle:{"border":"0","height":"37rem","width":"310px"},attrs:{"src":_vm.iframeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }